module.exports = __webpack_public_path__ + "static/img/mediaReportFour.d991af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mediaReportFour.png
// module id = kGBr
// module chunks = 1